import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import LayoutSiaLearner from '../../../Shared/Layout/LayoutSiaLearner'
import { SIA_NAVY, SIA_GOLD_ACTIVE_BG } from '../../../constants/siaTheme'

function DownloadIcon() {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 3v10.17l-3.88-3.88L6 11l6 6 6-6-1.12-1.12L13 13.17V3h-2zm-6 16v2h14v-2H5z" />
        </svg>
    )
}

const DEFAULT_COVER = '/images/logo-yireh-grande.png'

const BooksCatalog = ({ books }) => {
    return (
        <>
            <div
                className="rounded-2 mb-8 py-5 px-4 text-center text-white text-uppercase fw-bold fs-3"
                style={{ backgroundColor: SIA_NAVY, letterSpacing: '0.06em' }}
            >
                Nuestros libros
            </div>

            <p className="text-center fst-italic text-gray-700 fs-5 mb-2">«Cada libro es un mundo esperando ser descubierto»</p>
            <p className="text-center text-gray-600 mb-10">Te dejamos algunos libros que te serán de ayuda en tu día a día…</p>

            <Row className="g-6 g-lg-8 mb-15">
                {books.length === 0 && (
                    <Col xs={12}>
                        <p className="text-center text-muted py-15">Pronto publicaremos el catálogo de libros.</p>
                    </Col>
                )}
                {books.map((book) => (
                    <Col key={book.id} xs={12} sm={6} md={4} lg={2}>
                        <Card className="h-100 shadow-sm border border-gray-200 overflow-hidden">
                            <div className="bg-white px-2 pt-4 pb-2 d-flex align-items-center justify-content-center" style={{ minHeight: '240px' }}>
                                <img
                                    src={book.cover_url || DEFAULT_COVER}
                                    alt=""
                                    className="img-fluid"
                                    style={{ maxHeight: '220px', width: '100%', objectFit: 'contain' }}
                                />
                            </div>
                            <Card.Body className="text-center py-4 px-3 border-top bg-white">
                                <Card.Title className="fs-7 fw-semibold text-gray-900 lh-sm mb-0">«{book.title}»</Card.Title>
                            </Card.Body>
                            <div className="bg-light py-3 px-2 text-center border-top">
                                {book.has_download ? (
                                    <a
                                        href={route('sia.capacitacion.libros.download', book.id)}
                                        className="d-inline-flex align-items-center justify-content-center rounded-1 text-decoration-none"
                                        style={{ backgroundColor: SIA_GOLD_ACTIVE_BG, width: '42px', height: '42px' }}
                                        title="Descargar"
                                    >
                                        <DownloadIcon />
                                    </a>
                                ) : (
                                    <span className="text-muted small">Sin archivo</span>
                                )}
                            </div>
                        </Card>
                    </Col>
                ))}
            </Row>
        </>
    )
}

BooksCatalog.layout = (page) => <LayoutSiaLearner title="Libros | SIA">{page}</LayoutSiaLearner>

export default BooksCatalog
